<template>
  <el-col :span="18" class="content-right" v-loading="loading">
    <!-- :type="tradeType" -->
    <tradeOrderList ref="tradeAllOrderList" :orderList="orderList" :queryParams="queryParams" @handleFilter="getAllList"></tradeOrderList>
    <div class="pagination">
      <el-pagination
        v-if="orderList.length !== 0"
        background
        :total="total"
        layout="total, prev, pager, next"
        :current-page="queryParams.page"
        :page-size="queryParams.pageSize"
        @current-change="handleCurrentChange"
      />
    </div>
  </el-col>
</template>

<script>
import tradeOrderList from './components/trade-allorder-list.vue'
import { localStorageUtils } from '@/utils/localstorage'
export default {
  name: 'AllOrder',
  components: {
    tradeOrderList
  },
  data () {
    return {
      loading: false,
      total: null,
      orderList: [],
      tradeType: '',
      queryParams: {
        page: 1,
        pageSize: 10,
        applyType: '',
        verifyStatus: '', // 订单状态
        queryStatus: '', // 订单子状态
        vendorName: '', // 服务商名称
        pocName: '', // 门店名称
        pocCode: '', // 订单编号
        applyStatus: '',
        solutionStatus: '',
        acceptanceStatus: '',
        requirementStatus: '',
        executionStatus: '',
        isOwner: '',
        pledgePaid: '',
        applyClientLevel: '',
        queryType: '',
        queryRegionCode: '', // bu
        queryBuCode: '', // region
        tradeStackWeek: '',
        tradeStackWeekStatus: '',
        waitClockIn: '',
        stackSpecs: '',
        applyNumber: '',

        execType: '',
        execTypeSub: '', // 选择项目
        isAll: '',
        keyword: '',
        orderCol: '',
        orderMethod: '',
        applyTypeTemp: '',
        applyStatusTemp: '',
        clientType: '',
        waitSupplement: ''
      }
    }
  },

  beforeRouteLeave (to, from, next) {
    if (to.name === 'bcc-order-info') {
      localStorageUtils.set('bccAllQueryParams', JSON.stringify(this.queryParams))
    } else {
      localStorageUtils.remove('bccAllQueryParams')
    }
    next()
  },

  watch: {
    '$route': {
      handler (to, from) {
        this.queryParams.page = 1
        this.getQueryParams()
      },
      immediate: true
    }
  },

  methods: {
    getQueryParams () {
      if (localStorageUtils.get('bccAllQueryParams')) {
        this.queryParams = JSON.parse(localStorageUtils.get('bccAllQueryParams'))
        this.$nextTick(() => {
          this.$refs.tradeAllOrderList.showStatus()
        })
      }
      this.getAllList()
      localStorageUtils.remove('bccAllQueryParams')
    },
    // 获取所有订单
    getAllList () {
      this.loading = true
      this.$store
        .dispatch('getSeekQuatation', this.queryParams)
        .then((response) => {
          if (response.data.resultCode === '0') {
            // console.log(response.data, "获取所有订单");
            this.orderList = response.data.resultData.tradeApplyList || []
            this.total = response.data.resultData.pageInfo.totalCounts
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    /** 获取审批订单 */
    getApproveList () {
      this.$store
        .dispatch('getApproveList', this.queryParams)
        .then((response) => {
          if (response.data.resultCode === '0') {
            this.orderList = response.data.resultData.tradeApplyList || []
            this.total = response.data.resultData.pageInfo.totalCounts

            if (this.orderList.length) {
              this.orderList.forEach((item) => {
                this.$set(item, 'checked', false)
              })
            }
            this.$refs.tradeOrderList.showCheckBox('tradeOrder')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    handleCurrentChange (val) {
      this.queryParams.page = val
      // if (this.tradeType === "all" || this.tradeType === "closed") {
      this.getAllList()
      // } else if (
      //   this.tradeType === "waitApprove" ||
      //   this.tradeType === "waitCheck" ||
      //   this.tradeType === "waitAccept"
      // ) {
      //   this.getApproveList();
      // }
    }

  }
}
</script>

<style lang="scss" scoped>
.pagination .el-pagination {
  text-align: center;
}
</style>
